import { type FC, type ReactNode } from 'react';

import { Form, FormButtons } from '@zen/Components/Form';
import type { FormInstance } from '@zen/Components/types';
import { Button, Modal } from '@zen/DesignSystem';
import type { IOkOrErrorResult } from '@zen/utils/OkOrErrorResult';

import NetPromoterScoreQuestions from './NetPromoterScoreQuestions';
import type { NetPromoterScoreSurveyValues } from './types';
import { validationSchema } from './validation';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: NetPromoterScoreSurveyValues) => Promise<IOkOrErrorResult>;
  onSuccess: () => void;
}

const NetPromoterScoreSurvey: FC<Props> = ({ isOpen, onClose, onSubmit, onSuccess }) => {
  const renderFormButtons = ({ isSubmitting }: FormInstance<NetPromoterScoreSurveyValues>): ReactNode => {
    return (
      <FormButtons isSubmitting={isSubmitting} layout="fixed" text="Submit feedback">
        <Button onClick={onClose} variant="secondary">
          Skip for now
        </Button>
      </FormButtons>
    );
  };

  const handleSubmit = (values: NetPromoterScoreSurveyValues): Promise<IOkOrErrorResult> => {
    return onSubmit(values);
  };

  return (
    <Modal
      closeOnClickAway={false}
      isOpen={isOpen}
      onClose={onClose}
      title="We'd love your feedback! Let us know how we're performing."
      width="medium"
    >
      <Form
        formButtons={renderFormButtons}
        formName="NetPromoterScoreSurvey"
        initialValues={{
          additionalComments: '',
          businessSupport: '',
          marketConditions: null,
          operationalServices: null,
          recommendation: null,
          visibility: null
        }}
        onSubmit={handleSubmit}
        onSuccess={onSuccess}
        validationSchema={validationSchema}
      >
        {() => <NetPromoterScoreQuestions />}
      </Form>
    </Modal>
  );
};

export default NetPromoterScoreSurvey;
